import React from 'react';
import { jsonForm } from '@europrocurement/flexy-form/utils/types/formTypes';
import { AccordionJsonForms, DossierFormulaire } from '@europrocurement/l2d-modules';
import { Scrollbar } from '@europrocurement/flexy-components';
import { Box } from '@mui/material';
import _ from 'lodash';

export type DossierFormsBodyProps = {
    formulaire: DossierFormulaire;
    onChange: (data: Record<string, unknown>) => void;
};

const DossierFormsBody: React.FunctionComponent<DossierFormsBodyProps> = function (props) {
    const { formulaire, onChange: handleChange } = props;
    const divRef = React.useRef<HTMLDivElement>(null);

    if (!formulaire.formulaireJson) {
        return null;
    }

    const createObjectFromForm = (formConfig: jsonForm) => {
        const result = {};
        const pages = formConfig?.pages || [];

        if (!pages.length) {
            return result;
        }

        pages.forEach((page) => {
            (page.sections || [])
                .filter((section) => 'defaultvalue' in section && section.name)
                .forEach((section) => {
                    const path = section.name.split('.');
                    let current = result;

                    path.forEach((key, index) => {
                        if (index === path.length - 1) {
                            current[key] = section.defaultvalue;
                        } else {
                            if (!current[key]) {
                                current[key] = {};
                            }
                            current = current[key];
                        }
                    });
                });
        });

        return result;
    };

    const defaultValues = _.merge(
        {},
        createObjectFromForm(formulaire.formulaireJson as jsonForm),
        formulaire.prestationJson,
    );

    return (
        <Box
            sx={{ height: '85%', width: '100%' }}
            ref={divRef}
            data-testid="form-validation-bloc"
        >
            <Box
                sx={{
                    width: divRef.current ? Math.round(divRef.current?.clientWidth) - 1 : '100%',
                    height: '100%',
                }}
            >
                <Scrollbar>
                    <AccordionJsonForms
                        json={formulaire.formulaireJson as jsonForm}
                        defaultValues={defaultValues as Record<string, unknown>}
                        formulaireId={formulaire.formulaireId as number}
                        formaliteId={formulaire.formaliteId}
                        visibility="BACK"
                        expanded
                        onChange={handleChange}
                    />
                </Scrollbar>
            </Box>
        </Box>
    );
};

export default DossierFormsBody;
